import type { ValuesType } from '@fifa-bsm/bo-frontend-shared/utils/types';

export const TicketStatusFilter = Object.freeze({
    NOT_ASSIGNED: 'not_assigned',
    NOT_ASSIGNED_AND_ON_WAITING_LIST: 'not_assigned_and_on_waiting_list',
    ASSIGNED: 'assigned',
    DISTRIBUTED: 'distributed',
    DISTRIBUTION_ROLLED_BACK: 'distribution_rolled_back',
} as const);

export type ITicketStatusFilter = ValuesType<typeof TicketStatusFilter>;
